import { useMutation } from "react-query";
import http from "infra/http";

function useDeletePasta() {
  return useMutation(
    (id: string) => {
      return http.delete(`/v1/documento/pastas/${id}`);
    },
    {
      retry: false,
    }
  );
}

export default useDeletePasta;
